(function (ws, win) {
    'use strict';
    ws.views.productlistingpage = Backbone.View.extend({

        /**
         * event handlers
         */
        events: {
            'click .list-view': 'listViewShow',
            'click .grid-view': 'gridViewShow',
            'change .sortOptions': 'refreshList',
            'change .sizeOptions': 'refreshList'

        },

        /**
         * Initialize
         */
        initialize: function () {

            this.sortOrder = this.$('.cpf-sort').val();
            this.pageSize = this.$('.cpf-page-size').val();
            this.$columns = $('.indivisual-product');
            this.$listView = this.$('.listview');
            this.$gridView = this.$('.gridview');

            var localSto = localStorage.getItem('viewOfproduct');

            if (localSto == 'listView') {
                this.$gridView.removeClass('active');
                this.$listView.addClass('active');
                this.listViewShow();
            }

            if (localSto == 'gridView') {
                this.$gridView.addClass('active');
                this.$listView.removeClass('active');
                this.gridViewShow();
            }

            var _this = this;
            this.totalProducts = parseInt($('.cpl-items li').length);
            if ($('.cpl-items ul').attr('data-productLimit')) {
                this.productsLoadLimit = parseInt($('.cpl-items ul').attr('data-productLimit'));
            } else {
                this.productsLoadLimit = 15;
            }

            this.products = [];
            this.limitStart = 0;
            this.limitEnd = this.productsLoadLimit;
            if (this.totalProducts > this.productsLoadLimit) {
                this.loopCount = this.totalProducts / this.productsLoadLimit;
            }
            else {
                this.loopCount = 1;
            }

            $(window).on('load', function () {
                _this.customerPriceAndATPOnload();
            });

        },

        /**
         * Refresh List on change
         * @param {Object} e
         */
        refreshList: function (e) {
            let _this = this;
            let searchQuery;
            if ($('#searchText').val()) {
                searchQuery = $('#searchText').val().toLocaleUpperCase() + ':relevance:vendorProducts:' + $('#selectedCountryCode').val() + ':productSalesOrgList:' + $('#selectedCountryCode').val();
            } else {
                searchQuery = $('#searchText').val() + ':relevance:vendorProducts:' + $('#selectedCountryCode').val() + ':productSalesOrgList:' + $('#selectedCountryCode').val();
            }

            var $checkboxes = $('.custom-checkbox');
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true && $(checkbox).prop('disabled') !== true) {
                    if ($(checkbox).data('facetcode') === 'categories') {
                        searchQuery = searchQuery + ':categories:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'vendor') {
                        searchQuery = searchQuery + ':vendor:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'isIntangible') {
                        searchQuery = searchQuery + ':isIntangible:' + $(checkbox).val();
                    }
                }
            });

            let $form = $('#filter_form');

            $('#searchOnFieldValue').val($('#searchOnField').val());
            $('#searchType').val($('#searchType').val());
            $('#applyFilter').val('false');
            $('#searchQuery').val(searchQuery.replace(/ /g, '+'));
            if ($('.sizeOptions').val() != undefined) {
                $('#pageSizeValue').val($('.sizeOptions').val());
            }

            $('#sortCodeValue').val($('.sortOptions').val());
            $form.submit();
        },

        customerPriceAndATPOnload: (function () {
            var _this = this;
            for (let i = 1; i <= this.totalProducts; i++) {
                this.productCode = $('.cpl-items li:nth-child(' + i + ')').attr('data-productName');
                _this.products.push(this.productCode);
            }

            var j = 0;
            if (this.loopCount > 0) {
                _this.customerPriceAndATPQueue(this.limitStart, this.limitEnd);
                this.loopCount -= 1;
                this.limitStart += this.productsLoadLimit;
                this.limitEnd += this.productsLoadLimit;
            }
        }),

        customerPriceAndATPQueue: function (limitStart, limitEnd) {
            var _this = this;
            var sets = [];
            sets = _this.products.slice(limitStart, limitEnd);
            _this.model.clear();
            _this.model.set({
                productCodes: sets
            });
            _this.model.save().done(function (response) {
                if (response) {
                    _.each(response, function (response) {
                        var responseID = encodeURIComponent(response.code);
                        var responseCode = responseID.replace(/%/g, '-PCT-').replace(/\./g, '-DOT-');
                        if (response.customerPrice.formattedValue != null) {
                            $('.cpl-cusprice-' + responseCode).text(response.customerPrice.formattedValue);
                            $('.cpl-cusprice-text-' + responseCode).removeClass('hide');
                        }

                        _.each(response.productATPList, function (prodAvail) {
                            $('.cpl-quantity-inStock-' + limitStart + '-' + responseCode).removeClass('hide');
                            $('.cpl-quantity-inStock-' + limitStart + '-'  + responseCode).append('<strong class="cpl-available-text-color available-plant">' + prodAvail.plantName + ':</strong>' + prodAvail.stockLevel);
                        });
                    });
                    _this.customerPriceAndATPOnload();
                }
            }.bind(this)).fail(function (error) {
                _this.customerPriceAndATPOnload();
                console.log(error);
            }.bind(this));
        },

        /**
         * Refresh List on selection of grid view option
         * @param {Object} e
         */
        gridViewShow: function (e) {
            var i;

            // storing the grid veiw value in local storate
            localStorage.setItem('viewOfproduct', 'gridView');

            // toggling the active class on gridView click
            this.$gridView.addClass('active');
            this.$listView.removeClass('active');

            let k = 1;
            for (i = 0; i < this.$columns.length; i++) {
                let j = (k + i) % 3;
                if (j != 0) {
                    j = 'one';
                } else {
                    j = 'last';
                }

                this.$columns[i].style.width = '32%';
                this.$columns[i].style.float = 'left';
                $(this.$columns[i]).addClass('listlayout');
                $(this.$columns[i]).addClass('listlayout' + j);
            }

        },

        /**
         * Refresh List on selection of list view option
         * @param {Object} e
         */
        listViewShow: function (e) {
            var i;

            // storing the list veiw value in local storate
            localStorage.setItem('viewOfproduct', 'listView');

            // toggling the active class on listView click
            this.$gridView.removeClass('active');
            this.$listView.addClass('active');

            for (i = 0; i < this.$columns.length; i++) {
                this.$columns[i].style.width = '100%';
                $(this.$columns[i]).removeClass('listlayout');
            }

        }
    });
})(westcon, window);
